<div class="fixed-wrapper" *ngIf="showCallStateControl">
  <div
    class="fixed-overlay flex"
    [class.ringing-animation]="callStateData?.callState == TelephonyCallState.Ringing"
  >
    <!--    <span-->
    <!--      class="beta-symbol"-->
    <!--      pTooltip="This feature is currently in beta, please report bugs/suggestions to IT"-->
    <!--      >BETA</span-->
    <!--    >-->
    <div class="inner-container flex-grow-1">
      <div class="telephone-icon">
        <img
          [pTooltip]="callStateData.callStateText"
          tooltipPosition="left"
          [src]="callStateData.callStateIcon"
        />
      </div>
      <div class="call-container" *ngIf="callStateData.callerInfo">
        <div class="caller-name">{{ callStateData.callerInfo.name }}</div>
        <div class="call-status">{{ getCallStatusText() }}</div>
      </div>

      <div *ngIf="actionText" class="action-text" (click)="onAction()">
        {{ actionText }}
      </div>
    </div>
    <div
      class="align-center align-items-center clear-call flex h-100 px-3"
      pTooltip="Clear Call. Note: You will no longer be able to use log call once call cleared"
      (click)="clear()"
    >
      <i class="fa fa-close"></i>
    </div>
  </div>
</div>

<div class="fixed-wrapper" *ngIf="showDefaultControl">
  <div class="fixed-overlay flex">
    <!--    <span-->
    <!--      class="beta-symbol"-->
    <!--      pTooltip="This feature is currently in beta, please report bugs/suggestions to IT"-->
    <!--      >BETA</span-->
    <!--    >-->
    <div class="dialpad-logo-container">
      <img src="assets/images/telephony/dialpad.jpeg" class="dialpad-logo" />
    </div>
    <div class="inner-container flex-grow-1">
      <p-avatar
        [label]="telephonyUser.initials"
        shape="circle"
        styleClass="mr-2"
        [style]="{ 'background-color': '#334155', color: '#ffffff' }"
      ></p-avatar>
      <div class="call-container">
        <div class="flex justify-content-between">
          <div class="font-bold text-base">{{ telephonyUser.display_name }}</div>
          <div>EXT: {{ telephonyUser.extension }}</div>
        </div>
        <div class="call-status" [class.online]="telephonyUser.is_online">
          {{ userDisplayStatus }}
        </div>
      </div>

      <div *ngIf="actionText" class="action-text" (click)="onAction()">
        {{ actionText }}
      </div>
    </div>
  </div>
</div>
<!--<div class="flex justify-content-between"><div class="caller-name font-bold text-base">Dev Ops</div><div>EXT: 00060</div></div>-->
<p-dialog
  header="Log Call"
  [(visible)]="showLogCallDialog"
  [modal]="true"
  [responsive]="true"
  [style]="{ 'max-width': '950px' }"
>
  <form [formGroup]="logForm" *ngIf="selectedCall">
    <!-- call information box (dropdown) -->
    <div class="call-info-wrapper">
      <p-dropdown
        [options]="recentCallDropdownOptions"
        [(ngModel)]="selectedCall"
        [style]="{ width: '100%' }"
        styleClass="call-info-dropdown"
        [ngModelOptions]="{ standalone: true }"
        appendTo="body"
      >
        <ng-template let-item pTemplate="selectedItem">
          <app-call-info-box [call]="item?.value"></app-call-info-box>
        </ng-template>
        <ng-template let-item pTemplate="item">
          <app-call-info-box [call]="item?.value"></app-call-info-box>
        </ng-template>
      </p-dropdown>
    </div>

    <!-- task section -->
    <div
      *ngIf="internalTelephonyEventData?.telephonyJobInfo?.tasks?.length == 1"
      style="display: grid; grid-template-columns: 200px 1fr"
      class="mt-4"
    >
      <div>
        <div class="task-label-main">Task Associated</div>
        <div class="task-label-sub">with this call</div>
      </div>
      <div>
        <telephony-control-task-table
          [jobInfo]="internalTelephonyEventData.telephonyJobInfo"
          [selectedTask]="selectedTask"
        ></telephony-control-task-table>
      </div>
    </div>
    <div
      *ngIf="internalTelephonyEventData?.telephonyJobInfo?.tasks?.length > 1"
      style="display: grid; grid-template-columns: 200px 1fr"
    >
      <div>
        <div class="task-label-main">
          Select One Task
          <span
            *ngIf="!selectedTask"
            style="color: red; font-size: 1.2em; cursor: pointer"
            pTooltip="No Task Selected"
            >*</span
          >
        </div>
        <div class="task-label-sub">Associated with this call</div>
      </div>
      <div>
        <telephony-control-task-table
          [jobInfo]="internalTelephonyEventData.telephonyJobInfo"
          [(selectedTask)]="selectedTask"
        ></telephony-control-task-table>
      </div>
    </div>

    <div
      *ngIf="loggingFromDeployment"
      style="display: grid; grid-template-columns: 200px 1fr; margin-top: 24px"
    >
      <div>
        <div class="task-label-main">Outcome</div>
        <div class="task-label-sub">For Job Deployment History</div>
      </div>
      <div>
        <p-dropdown
          name="outcomeOptions"
          [options]="outcomeOptions"
          placeholder="Select outcome"
          autoWidth="false"
          [required]="true"
          [style]="{ width: '100%' }"
          formControlName="contactOutcomeId"
        ></p-dropdown>
      </div>
    </div>

    <!-- notes section -->
    <div style="display: grid; grid-template-columns: 200px 1fr; margin-top: 24px">
      <div>
        <div class="task-label-main">Notes</div>
        <div class="task-label-sub">For Job History</div>
      </div>
      <div>
        <textarea
          pInputTextarea
          formControlName="note"
          style="width: 100%; height: 100px"
          id="noteInput"
          #noteInput
        ></textarea>
      </div>
    </div>

    <div class="notes-checkbox-container">
      <div
        class="event-type-checkbox flex align-items-center"
        pTooltip="When checked, VME users can see this note in Job History"
        tooltipStyleClass="xtooltip"
        tooltipPosition="top"
      >
        <p-checkbox formControlName="logEngineius" binary="true" label="Engineius"></p-checkbox>
      </div>
      <div
        class="event-type-checkbox flex align-items-center"
        pTooltip="When checked, the customer who created the order can see this note in Job History"
        tooltipStyleClass="xtooltip"
        tooltipPosition="top"
      >
        <p-checkbox formControlName="logCustomer" binary="true" label="Customer"></p-checkbox>
      </div>
      <div
        class="event-type-checkbox flex align-items-center"
        pTooltip="When checked, the supplier assigned to this job can see the note in Job History"
        tooltipStyleClass="xtooltip"
        tooltipPosition="top"
      >
        <p-checkbox formControlName="logSupplier" binary="true" label="Supplier"></p-checkbox>
      </div>
    </div>
  </form>

  <!-- footer -->
  <p-footer>
    <button
      type="button"
      pButton
      (click)="showLogCallDialog = false"
      class="ui-button-tertiary"
      label="Cancel"
    ></button>
    <button
      type="submit"
      (click)="logCall()"
      class="ui-button-primary"
      pButton
      label="Log Call"
      [disabled]="!selectedCall"
    ></button>
  </p-footer>
</p-dialog>
